var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FFD49D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 39,
    fill: "#191919"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 36,
    fill: "#FFD49D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 39.75C48.3827 39.75 51.125 37.0077 51.125 33.625C51.125 30.2423 48.3827 27.5 45 27.5C41.6173 27.5 38.875 30.2423 38.875 33.625C38.875 37.0077 41.6173 39.75 45 39.75Z",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 59.875C27.5 52.143 34.5515 45.875 43.25 45.875",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.625 59C57.5245 59 59.875 56.6495 59.875 53.75C59.875 50.8505 57.5245 48.5 54.625 48.5C51.7255 48.5 49.375 50.8505 49.375 53.75C49.375 56.6495 51.7255 59 54.625 59Z",
    stroke: "#191919",
    strokeWidth: 2.625
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 57.25L62.5 59.875",
    stroke: "#191919",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentOffline);
export default __webpack_public_path__ + "static/media/agent-offline.26233e49f6d26f8aedf4b69f1b508fd6.svg";
export { ForwardRef as ReactComponent };